import {
  ArrowLeftIcon,
  Drawer,
  Heading,
  IconButton,
  Sidebar,
} from '@buffer-mono/popcorn'

import { SettingsNavigationContent } from '~publish/pages/Settings/SettingsNavigationContent'

import { useMobileSidebar } from './MobileSidebarContext'

import styles from './MobileSettingsDrawer.module.css'

import type { JSX } from 'react'

export function MobileSettingsDrawer(): JSX.Element {
  const { settingsOpen, setSettingsOpen, closeAll } = useMobileSidebar()

  return (
    <Drawer open={settingsOpen} onOpenChange={setSettingsOpen}>
      <Drawer.Content className={styles.drawer} handle={false}>
        <Drawer.Header className={styles.header}>
          <IconButton
            label="Back to menu"
            variant="tertiary"
            size="small"
            onClick={(): void => setSettingsOpen(false)}
          >
            <ArrowLeftIcon />
          </IconButton>
          <Heading as="h2" size="small">
            Settings
          </Heading>
        </Drawer.Header>
        <Drawer.Body className={styles.body}>
          <Sidebar.Provider>
            <SettingsNavigationContent onNavigate={closeAll} />
          </Sidebar.Provider>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer>
  )
}
